import { memo } from "react";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import {
	getMailboxMessageDetailPath,
	getReportMailerMessageId,
	isReportFromMailbox,
} from "src/modules/mailer/helpers";

const FromMailboxCaseIndicator = ({ t, report }) => {
	if (!isReportFromMailbox(report)) {
		return null;
	}

	const messageId = getReportMailerMessageId(report);
	const icon = (
		<i
			className="mdi mdi-email-outline font-size-16"
			aria-hidden="true"
		></i>
	);

	if (!messageId) {
		return (
			<span
				className="text-muted"
				title={t("Created from mailbox")}
				aria-label={t("Created from mailbox")}
			>
				{icon}
			</span>
		);
	}

	return (
		<Link
			to={getMailboxMessageDetailPath(messageId)}
			className="text-muted"
			title={t("Open original message")}
			aria-label={t("Open original message")}
			onClick={(event) => event.stopPropagation()}
		>
			{icon}
		</Link>
	);
};

export default withNamespaces()(memo(FromMailboxCaseIndicator));
